import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BadgesService, ListItemModel } from 'src/app/core/services/api-services';

@Component({
  selector: 'app-badge-autocomplete',
  templateUrl: './badge-autocomplete.component.html',
  styleUrl: './badge-autocomplete.component.scss',
  standalone: false,
})
export class BadgeAutocompleteComponent {
  @Input() itemControl!: FormControl;
  @Input() label!: string;
  @Input() error: string | null = null;
  @Input() minCharacters: number = 0;
  @Output() selected = new EventEmitter<ListItemModel>();

  constructor(private readonly badgesService: BadgesService) { }

  search = (value: string | null) => {
    return this.badgesService.searchBadges(value ?? '');
  }

  getItemName = (item: any) => {
    return (item as ListItemModel)?.name;
  }

  onSelected(value: any) {
    this.selected.emit(value);
  }
}
